import React from 'react';

import map from 'lodash/map';
import get from 'lodash/get';

import { connect } from 'react-redux';

import SlideshowBase from './slideshow_base.jsx';
import SlideshowItem from './slideshow_item.jsx';
import SlideshowThumbnailComponentForViewer from './slideshow_thumbnails_nav.thumbnail_container.jsx';
import { getBackgroundStyle } from 'zoomforth_codesbane_viewer/lib/section_backgrounds.js';
import { getHeightStyle } from 'zoomforth_codesbane_viewer/lib/sections.js';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import {
  getAssetForContent,
  getSectionSelectedContent,
  getOrderedNonEmptyContentItemsForSection,
  getSectionAllowAutoplayContentUuid,
  getIsCurrentSubpageFullPageSection,
  getSectionBackgroundData,
  getCurrentSubpage,
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  selectSectionContent,
  syncToUrlSubpageAndContent,
  handleSlideshowSlideDisplayTracking,
  setOverlayContentUuid,
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';


const mapStateToProps = (state, { section }) => {
  // Note we dont use getOrderedAndSelectedNonEmptyContentItemsForSection here
  // because we try to replicate how the code was found--to minimize logic changes--
  // however, it may be *more right* to use that func
  const contentItems = getOrderedNonEmptyContentItemsForSection(state, section);

  let selectedContentItem = getSectionSelectedContent(state, section.id);

  const isFullPage = getIsCurrentSubpageFullPageSection(state);
  const height = getHeightStyle(section);

  const sectionBackgroundData = getSectionBackgroundData(state, section);
  const backgroundStyle = getBackgroundStyle(sectionBackgroundData);

  const SlideshowThumbnailComponent = SlideshowThumbnailComponentForViewer;

  const autoplay = selectedContentItem ?
      getSectionAllowAutoplayContentUuid(state, section.id) === selectedContentItem.uuid
    :
      false;

  const contentItemAssetPairs = map(
      contentItems, 
      (contentItem)=> ({ contentItem, asset: getAssetForContent(state, contentItem) })
    );

  const assetUrlsForPreload = map(contentItemAssetPairs, ({ asset }) =>
    get(asset, 'displayImage')
  );

  const subpageId = getCurrentSubpage(state).id;

  return {
    subpageId,
    height,
    assetUrlsForPreload,
    isFullPage,
    backgroundStyle,
    contentItemAssetPairs,
    videoishPlayerProps: {
      autoplay: !!autoplay,
    },
    selectedContentItem,
    SlideshowThumbnailComponent,
    sectionId: section.id,
    section,
    isUsingLegacySlideshow: section.isUsingLegacySlideshow
  };
};

const mapDispatchToProps = (dispatch, { section }) => ({

  onOverlayOpen: (uuid)=> {
    dispatch(setOverlayContentUuid(uuid, { isOverlayOpenedFromSlideshow: true }));
  },
  onSelectContentClick: (contentItem, { shouldSyncUrl = true } = {}) => {
    dispatch(selectSectionContent(section, contentItem));

    if (shouldSyncUrl) {
      dispatch(syncToUrlSubpageAndContent(section.id));
    }
  },
  onSlideSelect: (contentItem) => {
    dispatch(handleSlideshowSlideDisplayTracking(section, contentItem));
  },
  onSlideDisplay: (contentItem) => {
    dispatch(handleSlideshowSlideDisplayTracking(section, contentItem));
  },
  videoishPlayerProps: {
    onEnded: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoEnded(contentItem, eventData);
    },
    onError: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoError(contentItem, eventData);
    },
    onPause: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoPause(contentItem, eventData);
    },
    onPlay: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoPlay(contentItem, eventData);
    },
    onSeeked: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoSeeked(contentItem, eventData);
    },
    onStart: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoStart(contentItem, eventData);
    },
    onTimeUpdate: (contentItem, eventData) => {
      getTracker().handleSlideshowVideoTimeUpdate(contentItem, eventData);
    },
  },
});

const SlideshowSectionForViewer = (props) => (
  <SlideshowBase SlideshowItemComponent={SlideshowItem} {...props} />
);

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => ({
  videoishPlayerProps: {
    ...propsFromState.videoishPlayerProps,
    ...propsFromDispatch.videoishPlayerProps,
  },
  ...propsFromState,
  ...propsFromDispatch,
  ...ownProps
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SlideshowSectionForViewer);
